import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAppState } from './RetailerFitGuide_StateContext.jsx';
import { track_toggleJourney } from './Script/RetailerFitGuide_Tracking.js';
import { TRACK_EVENT_TYPE } from './Script/RetailerFitGuide_Constants.js';
import RetailerFitGuide_Downloads from './Shared/RetailerFitGuide_Downloads.jsx';
export const RetailerFitGuide_Overview = () => {
  let selectImageUrl = _THULEDATA?.retailerFitGuide?.selectCarImage;
  let refitImageUrl = _THULEDATA?.retailerFitGuide?.refitImage;

  const { translations, clearSettings } = useAppState();

  useEffect(() => {
    clearSettings();
  }, []);

  const cacheBreaker = `?v=${new Date().getFullYear()}-${new Date().getMonth() + 1}`;

  const guideFiles = [
    {
      downloadId: 'HitchRackClearance',
      fileName: 'Hitch rack clearance guide',
      url: `https://www.thule.com/-/s/approved/std.lang.all/18/25/671825.pdf${cacheBreaker}`,
    },
    {
      downloadId: 'CargoBoxClearance',
      fileName: 'Cargo box clearance guide',
      url: `https://www.thule.com/-/s/approved/std.lang.all/90/75/649075.pdf${cacheBreaker}`,
    },
    {
      downloadId: 'ThuleLoadBarUpsizer',
      fileName: 'Thule Load Bar Upsizer',
      url: `https://www.thule.com/-/s/approved/std.lang.all/iz/er/load-bar-upsizer.pdf${cacheBreaker}`,
    },
    {
      downloadId: 'ThuleRooftopTentGuidelines',
      fileName: 'Thule Rooftop Tent Guidelines',
      url: `https://www.thule.com/-/s/approved/std.lang.all/02/00/670200.pdf${cacheBreaker}`,
    },
  ];
  return (
    <div className="retailerFitGuide_Overview">
      <div>
        <ul className="mb-9">
          <li className="mb-4">
            <Link
              onClick={() => track_toggleJourney(true, TRACK_EVENT_TYPE.CARFIT)}
              to="roofrack"
              className="linkbutton"
            >
              <h2 className="heading3 mb-4">{translations.fitYourVehicle}</h2>
              <p className="paragraph--s mb-6">{translations.findRoofRacks}</p>
              <div className="d-flex justify-content-between align-items-end">
                <img src={selectImageUrl?.ImageURL} alt={selectImageUrl?.ImageAltText} />
                <i className="le-icon-arrow rot-180"></i>
              </div>
            </Link>
          </li>
          <li>
            <Link onClick={() => track_toggleJourney(true, TRACK_EVENT_TYPE.REFIT)} to="refit" className="linkbutton">
              <h2 className="heading3 mb-4">{translations.alreadyOwnRoofRack}</h2>
              <p className="paragraph--s mb-6">{translations.checkCurrentSystemFit}</p>
              <div className="d-flex justify-content-between align-items-end">
                <img src={refitImageUrl?.ImageURL} alt={refitImageUrl?.ImageAltText} />
                <i className="le-icon-arrow rot-180"></i>
              </div>
            </Link>
          </li>
        </ul>
        <RetailerFitGuide_Downloads title="Accessory Sizing Guide" files={guideFiles} />
      </div>
    </div>
  );
};
